import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, fontWeights } from '../../../defaultTheme';
import DropdownMenu from '../DropdownMenu';
import { ENTER_KEY, SPACE_KEY } from '../../../const/keyNames';
import query from '../../../const/mediaQueries';
export const ContentContainer = styled.div `
  overflow: ${({ isOpen }) => (isOpen ? 'auto' : 'hidden')};
  position: absolute;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  height: ${({ isOpen, heightFromTop }) => isOpen ? `calc(100vh - ${heightFromTop}px)` : '0'};
  top: ${({ isOpen }) => (isOpen ? '0' : '-200px')};

  transition: opacity 300ms ease-in 100ms, top 200ms ease-in;
  background-color: white;
  width: 100%;
  z-index: 2;

  @media ${query.lessThanMedium} {
    height: ${({ isOpen }) => (isOpen ? `auto` : '0')};
    position: inherit;
  }
`;
export const Divider = styled.div `
  margin-top: 16px;
  height: 1px;
  border-bottom: 1px solid ${colors.lightGrey};
`;
export const Wrapper = styled.div `
  position: relative;
`;
export const MenuItem = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 48px;
  padding-left: ${({ isDropdownItem }) => (isDropdownItem ? '58px' : '0')};
  font-weight: ${({ hasActiveStyles, hasRouteMatchChild }) => hasActiveStyles || hasRouteMatchChild
    ? `${fontWeights.bold}`
    : `${fontWeights.regular}`};
  background-color: ${({ hasActiveStyles, theme }) => hasActiveStyles ? theme.hoverBackground : 'inherit'};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${({ theme }) => theme.hoverBackground};
    }
  }
`;
// TODO: replace this with internal CL links when built
export const MenuLink = styled(Link) `
  color: ${({ theme }) => theme.body.text};
  text-decoration: none;

  &:visited {
    text-decoration: none;
  }
`;
// TODO: replace this with internal CL frame when built
export const IconFrame = styled.div `
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  margin-right: 8px;
`;
const TriggerWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${({ theme }) => theme.hoverBackground};
    }
  }
`;
export const HamburgerDropdown = styled(DropdownMenu) `
  ul {
    border: none;
    box-shadow: none;
    width: 100%;
    position: relative;
  }
`;
export const DropdownTrigger = ({ label, hasActiveStyles, hasRouteMatchChild, icon, menuClosedIcon, menuOpenIcon, toggleMenu, isOpen, dataType, dataReason }) => {
    React.useEffect(() => {
        if (hasRouteMatchChild && !isOpen && toggleMenu) {
            toggleMenu();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasRouteMatchChild]);
    return (_jsxs(TriggerWrapper, Object.assign({ role: "button", "data-type": dataType, tabIndex: 0, "data-reason": dataReason, className: dataType && 'ensightencustomevent', "data-object": dataType && 'link', onKeyUp: (event) => {
            if (event.key === ENTER_KEY || event.key === SPACE_KEY) {
                toggleMenu();
            }
        }, onClick: toggleMenu }, { children: [_jsxs(MenuItem, Object.assign({ hasActiveStyles: hasActiveStyles, hasRouteMatchChild: hasRouteMatchChild || isOpen }, { children: [icon && _jsx(IconFrame, { children: icon }), label] })), isOpen ? menuOpenIcon : menuClosedIcon] })));
};
//# sourceMappingURL=subcomponents.js.map